import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  inviteEmailContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    display: 'flex',
    position: 'relative',
    '@media (max-width: 620px)': {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    },
  },
  inviteInput: {
    width: 'calc(100% - 170px - 120px)',
    marginRight: 20,
    '@media (max-width: 620px)': {
      width: '100%',
      marginRight: 0,
      marginBottom: 20,
    },
  },
  inviteEmail: {
    '& .MuiChip-label': {
      color: theme.palette.common.black,
      fontWeight: 400,
      fontSize: 12,
      letterSpacing: 0.3,
      lineHeight: '26px',
    },
    '& .MuiAutocomplete-tag': {
      marginTop: 4,
      backgroundColor: '#D9D9D9',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '0px 20px 0 10px',
      // height: 42,
    },
    '& .MuiAutocomplete-inputRoot': {
      padding: '5px !important',
      minHeight: 42,
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 'calc(50% - 12px)',
    },
  },
  autoCompleteInput: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 30,
      // width: 430,
      minHeight: 44,
      top: -5,
    },
  },
  chip: {},
  sendInviteBox: {
    width: 170,
    '@media (max-width: 525px)': {
      width: 150,
    },
  },
  sendInviteButton: {
    float: 'right',
    marginRight: 15,
    width: 155,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 50,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 15,
    cursor: 'pointer',
    height: 42,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
    '@media (max-width: 525px)': {
      width: 135,
      marginRight: 10,
    },
  },
  previewEmailBox: {
    width: 120,
    '@media (max-width: 525px)': {
      width: 105,
    },
  },
  previewEmailText: {
    color: '#29BFFFCC',
    fontWeight: 800,
    fontSize: 14,
    letterSpacing: 0.3,
    lineHeight: '18px',
    cursor: 'pointer',
  },
  errorMessage: {
    fontSize: 14,
    letterSpacing: 0.35,
    color: theme.palette.error.main,
    marginLeft: 10,
    position: 'absolute',
    bottom: -23,
    '@media (max-width: 620px)': {
      display: 'block',
      position: 'static',
      width: '100%',
      paddingTop: 5,
    },
  },
  // dialog
  emailInvitationSubjectTxt: {
    fontSize: 20,
    color: theme.palette.common.black,
    fontWeight: 600,
    letterSpacing: 0.3,
    lineHeight: '28px',
    margin: '15px 0px',
  },
  emailInvitationText: {
    fontSize: 15,
    color: theme.palette.grey[50],
    fontWeight: 400,
    letterSpacing: 0.3,
    lineHeight: '28px',
    marginBottom: 5,
  },
  acceptInviteButton: {
    width: 157,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    marginTop: 5,
    marginBottom: 10,
    borderRadius: 50,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 15,
    height: 40,
    textTransform: 'none',
    pointerEvents: 'none',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  logoImg: {
    width: 132,
    height: 'auto',
    '@media (max-width: 1024px)': {
      width: 115,
    },
  },
}));
